module.exports = __webpack_public_path__ + "img/妖魔岭.26c42b9c.png";